import { execute } from '@/api/execute'
import { GET, PUT, POST, DELETE } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'manager/deliveries/companies'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  deleteById (id) {
    return execute(DELETE, `${ENDPOINT}/${id}/`)
  }
}
